import React, { ReactNode } from 'react';
import { Stack } from '@fiverr-private/layout_components';

interface MainRowProps {
    children: ReactNode;
    isFullWidth?: boolean;
}

export const MainRow = ({ children, isFullWidth }: MainRowProps) => (
    <Stack
        display="flex"
        alignItems="center"
        justifyContent="spaceBetween"
        gap={{ default: '9', sm: '4', lg: '8' }}
        width="100%"
        height="100%"
        paddingLeft={{ default: '6', sm: '8', md: '11' }}
        paddingRight={{ default: '6', sm: '8', md: '11' }}
        maxWidth={isFullWidth ? '100%' : '1440px'}
        marginLeft="auto"
        marginRight="auto"
    >
        {children}
    </Stack>
);
